import styled from "styled-components";
import { ReportActionButton } from "../../../Common";

export const SiteDetailPhotoButtons = styled(ReportActionButton)`
  width: 100%;
  margin: 0 0 13px 0;
`;
